import React from "react";

export default function Experience() {
  return (
    <div className="row justify-content-center">
      <h1 id="Experience" className="text-center py-4">
        Experience
      </h1>
      <div class="col-sm-10 col-lg-4">
        <h3>Education</h3>
        <dl class="row">
          <dt class="col-sm-3">2019 - 2020</dt>
          <dd class="col-sm-9">
            <p>Postgraduate Certificate in Education (PGCE)</p>
          </dd>

          <dt class="col-sm-3">2017 - 2019</dt>
          <dd class="col-sm-9">
            <p>
              Masters degree in Design at the Faculty of Fine Art, Music and
              Design, University of Bergen
            </p>
          </dd>
          <dt class="col-sm-3">2012 - 2016</dt>
          <dd class="col-sm-9">
            <p>
              Bachelors degree in Design at the Bergen Academy of Art and Design
            </p>
          </dd>
        </dl>
      </div>
      <div class="col-sm-10 col-lg-4">
        <h3>Work</h3>
        <dl class="row">
          <dt class="col-sm-3">2020 - present</dt>
          <dd class="col-sm-9">
            <p>Teacher in information technology and medieproduction</p>
          </dd>

          <dt class="col-sm-3">2016 - 2017</dt>
          <dd class="col-sm-9">
            <p>Teacher in Media communication</p>
          </dd>
        </dl>
      </div>
    </div>
  );
}
